import React, { FC, useCallback, useState } from 'react';

import { SettingPopupButton } from '../../skin/setting-popup-button/component';
import { BaseControlName } from '../../../types/controls';
import { PlayerContentType } from '../../../types/content';
import MoviePlayerControlPanel from '../../../../movie-player/ui/MoviePlayerControlPanel';
import { TrailerAudioSettingsPopupContainer } from '../../../../trailer-player/ui/trailer-audio-settings-popup/container';
import { useChangeSubtitlesPositionCallback } from '../../../hooks/skin/use-change-subtitles-position-callback';

interface Props {
    contentId: string;
    setIsHidingControlsBlocked: (isHidingControlsBlocked: boolean) => void;
    className?: string;
}

const TrailerPlayerControlPanel: FC<Props> = ({
    contentId,
    setIsHidingControlsBlocked,
    className,
}) => {
    const [isSubtitleSizeSettingsForceOpened, setIsSubtitleSizeSettingsForceOpened] =
        useState(false);

    const changeSubtitlePosition = useChangeSubtitlesPositionCallback();
    const onPopupToggle = useCallback(
        (isPopupOpened: boolean) => {
            setIsHidingControlsBlocked(isPopupOpened);
            changeSubtitlePosition(isPopupOpened);
        },
        [setIsHidingControlsBlocked, changeSubtitlePosition]
    );

    return (
        <MoviePlayerControlPanel
            contentId={contentId}
            onPopupToggle={onPopupToggle}
            className={className}
            renderRightControls={() => (
                <>
                    <TrailerAudioSettingsPopupContainer
                        onSubtitleSizeSettingsClick={() =>
                            setIsSubtitleSizeSettingsForceOpened(true)
                        }
                        contentId={contentId}
                    />
                    <SettingPopupButton
                        name={BaseControlName.ADJUSTMENT}
                        contentId={contentId}
                        contentType={PlayerContentType.TRAILER}
                        isSubtitleSizeSettingsForceOpened={isSubtitleSizeSettingsForceOpened}
                        setIsSubtitleSizeSettingsForceOpened={setIsSubtitleSizeSettingsForceOpened}
                    />
                </>
            )}
        />
    );
};

export default TrailerPlayerControlPanel;
